/**
 * Create an array of digits from a provide number (zero based)
 * @param {number} n
 * @returns {number[]}
 */
export const rangeArray = (n) => {
	return [...Array(n).keys()];
};
